<template>
  <div>
    <loading-screen/>
    <h1>Admin Panel Borkconnector</h1>
    <div class="blue-bar">
      <div>Overzicht bedrijven</div>
    </div>
    <div class="content">
      <button id="add-company-btn" class="btn btn-secondary" @click="addCompany()">Toevoegen</button>

      <datatables
          :rows="companies"
          :columns="getColumns()"
          tableID="companies"
          :tableInitOptions="tableInitOptions()"
          routerLinkClass="dt-router-link"
          :deleteFunction="deleteCompany"
          deleteClass="delete"
          :getDataClass="'get-data'"
          @rowSelected="rowSelected"
      ></datatables>
    </div>
  </div>
</template>

<script>
import {LoadingScreen} from 'motivate-framework-components';
import {getOptions} from '@/components/tableInitOptions';
import {getCompanies, putCompany, deleteCompany} from '@/firebase/companies';

import axios from 'axios';
//@vuese
// @group Wrappers
// Main page wrapper
export default {
  name: 'Home',
  components: {
    LoadingScreen
  },
  data() {
    return {
      tableInitOptions: getOptions,
      companies: []
    };
  },
  firestore() {
    return {};
  },
  methods: {
    async getCompanies() {
      this.$store.commit('setLoading', true);
      const companies = await getCompanies();
      this.companies = companies.data.companies;
      this.$store.commit('setLoading', false);
    },
    async openCompanySwal(company) {
      console.log(company)
      return this.$swal({
        customClass: 'swal-company',
        class: 'swal-company2',
        title: company ? 'Bedrijf wijzigen' : 'Bedrijf toevoegen',
        html:
            `<label for="swal-name">Naam</label><br/>` +
            `<input ${company ? 'value="' + company.name + '"' : ''} id="swal-name" class="swal2-input"><br/>` +
            `<label for="swal-databaseName">Database naam</label><br/>` +
            `<input ${company ? 'value="' + company.databaseName + '"' : ''}  placeholder="bork dino connector" id="swal-databaseName" class="swal2-input"><br/>` +
            `<label for="swal-serverIp">Server IP</label><br/>` +
            `<input ${company ? 'value="' + company.serverIp + '"' : ''}  id="swal-serverIp" class="swal2-input"><br/>` +
            `<label for="swal-databaseUrl">Server version</label><br/>` +
            `<input ${company ? 'value="' + company.serverVersion + '"' : ''}  type="url" id="swal-serverVersion" class="swal2-input">` +
            `<label for="swal-databaseUrl">Database version</label><br/>` +
            `<input ${company ? 'value="' + company.databaseVersion + '"' : ''}  type="url" id="swal-databaseVersion" class="swal2-input">` +
            `<label for="swal-databaseUrl">updated</label><br/>` +
            `<input type="checkbox"   type="url" id="swal-updated" class="swal2-input"   ${company && company.updated ? 'checked' : null} >` +
            `<br/>`,
        preConfirm: () => {
          try {
            const name = document.getElementById('swal-name').value;
            const databaseName = document.getElementById('swal-databaseName').value;
            const serverIp = document.getElementById('swal-serverIp').value;
            const serverVersion = document.getElementById('swal-serverVersion').value;
            const databaseVersion = document.getElementById('swal-databaseVersion').value;
            const updated = $('#swal-updated:checked').val() ? true : false
            console.log(1,document.getElementById('swal-updated').value,updated)
            return {name, databaseName, serverIp,serverVersion,databaseVersion,updated}
          } catch (e) {
            console.log(e)
            this.$swal.showValidationMessage('Alle velden met een * zijn verplicht.')
          }
        },
        confirmButtonText: 'Opslaan',
        showCancelButton: true,
        cancelButtonText: 'Annuleren',
        reverseButtons: true
      });
    },
    async addCompany() {
      const swalResponse = await this.openCompanySwal();
      if (swalResponse.value) {
        this.$store.commit('setLoading', true);
        const httpResponse = await putCompany(swalResponse.value);
        this.$store.commit('setLoading', false);
        if (httpResponse.status === 200) {
          this.$toasted.global.successRequest({
            message: 'Bedrijf opgeslagen'
          });
          this.getCompanies();
        } else {
          this.$toasted.global.failedRequest({
            message: 'Er is iets mis gegaan tijdens het opslaan.'
          });
        }
      }
    },
    async rowSelected(company) {
      const swalResponse = await this.openCompanySwal(company);
      if (swalResponse.value) {
        this.$store.commit('setLoading', true);
        const httpResponse = await putCompany({
          id: company.id,
          ...swalResponse.value
        });
        this.$store.commit('setLoading', false);
        if (httpResponse.status === 200) {
          this.$toasted.global.successRequest({
            message: 'Bedrijf bijgewerkt'
          });
          this.getCompanies();
        } else {
          this.$toasted.global.failedRequest({
            message: 'Er is iets mis gegaan tijdens het bijwerken.'
          });
        }
      }
    },
    async deleteCompany(company) {
      const swalresult = await this.$swal({
        title: 'Bedrijf verwijderen',
        text: `Weet je zeker dat je bedrijf '${company.name}' wilt verwijderen?`,
        type: 'warning',
        confirmButtonText: 'Ja',
        showCancelButton: true,
        cancelButtonText: 'Nee',
        reverseButtons: true
      });
      if (swalresult.value) {
        this.$store.commit('setLoading', true);
        const httpResponse = await deleteCompany(company.id);
        this.$store.commit('setLoading', false);
        if (httpResponse.status === 200) {
          this.$toasted.global.successRequest({
            message: 'Bedrijf verwijderd'
          });
          this.getCompanies();
        } else {
          this.$toasted.global.failedRequest({
            message: 'Er is iets mis gegaan tijdens het verwijderen.'
          });
        }
      }
    },
    getColumns() {
      let self = this;
      return [
        {
          data: 'name', name: 'Naam', visible: true, searchable: true, responsivePriority: 1
        },
        {
          data: null, name: 'Database naam', visible: true, searchable: false, responsivePriority: 1,
          render(data) {
            return data.databaseName ? data.databaseName : '<i>bork dino connector</i>'
          }
        },
        {
          data: 'serverIp', name: 'Server IP', visible: true, searchable: true, responsivePriority: 1,
        },
        {
          data: null, name: 'Server Version', visible: true, searchable: true, responsivePriority: 1,
          render(data) {
            return `${data.serverVersion}`
          }
        },
        {
          data: null, name: 'Database Version', visible: true, searchable: true, responsivePriority: 1,
          render(data) {
            return `${data.databaseVersion}`
          }
        },
        {
          data: null, name: 'Updated', visible: true, searchable: true, responsivePriority: 1,
          render(data) {
            return data.updated ? 'Ja' :'Nee'
          }
        },
        {
          data: null, name: 'Opties', orderable: false, responsivePriority: 1,
          render(data) {
            return '<i title="edit" class="far fa-edit action-icon get-data" data-target="#' + data.id + '" data-toggle="modal"></i>' +
                '<a class="delete action-icon" data-id="' + data.id + '"><i title="delete" class="far fa-trash-alt delete"></i></a>';
          }
        }
      ]
    },

  },
  computed: {},
  watch: {},
  created() {
    this.$store.commit('setLoading', false);
    this.getCompanies();

  }
};
</script>
<style lang="scss">
@import "./../assets/scss/main.scss";

.dataTables_filter {
  width: unset !important;
}

body.swal2-height-auto {
  height: inherit !important;
}

.swal2-input {
  margin-top: 0px !important;
  margin-bottom: 1rem !important;
}
</style>
<style lang="scss" scoped>
@import "./../assets/scss/main.scss";


h1 {
  color: $primary;
  text-align: center;
}

.blue-bar {
  margin-top: $defaultMarginBetweenBoxes;
  background-color: lighten($primary, 66%);
  height: calc(#{$defaultMarginBetweenBoxes} * 3);
  display: grid;
  color: $primary;
  align-content: center;
  text-align: center;
  font-weight: bold;
  font-size: $defaultFontSize;
  border-bottom: 1px solid $primary;
  border-top: 1px solid $primary;
  margin-bottom: $defaultMarginBetweenBoxes;
}

.content {
  padding: $defaultMarginBetweenBoxes;
}

#add-company-btn {
  float: left;
  margin-right: $defaultMarginBetweenBoxes;
}
</style>
